/**
 * 
 * @param {number} t 
 */
export const formatTime = function(t) {
    return t.toString(10).padStart(2, "0");
}

/**
 * 
 * @param {number} size 
 */
export const formatSize = function(size) {
    if (size<1024) return size + "B";
    if (size<1024*1024) return (size/1024).toFixed(2) + "KB";
    if (size<1024*1024*1024) return (size/1024/1024).toFixed(2) + "MB";
    return (size/1024/1024/1024).toFixed(2) + "GB";
}

export const createFormData = function (data) {
    const formdata = new FormData();
    for (let key in data) {
        formdata.append(key, data[key]);
    }
    return formdata;
}

/**
 * 
 * @param {string} timeString 
 */
export const safeParse = function(timeString) {
    return Date.parse(timeString.replace(/-/g, "/").replace(/\./g, "/"));
}

/** 判断某对象是否不为null也不为NaN */
export const isset = function (val) {
    return val != undefined && val != null && !(typeof val == 'number' && isNaN(val));
}

/** 深拷贝一个对象 */
export const clone = function (data) {
    if (!isset(data)) return null;
    // date
    if (data instanceof Date) {
        // @ts-ignore
        return new Date(data);
    }
    // array
    if (Array.isArray(data)) {
        const copy = new Array(data.length);
        for (let i = 0; i < data.length; i++) {
            copy[i] = clone(data[i]);
        }
        // @ts-ignore
        return copy;
    }
    // 函数
    if (data instanceof Function) {
        return data;
    }
    // object
    if (data instanceof Object) {
        const copy = {};
        for (let i in data) {
            copy[i] = clone(data[i]);
        }
        // @ts-ignore
        return copy;
    }
    return data;
}

/**
 * 抽取预渲染数据
 * @param {string} name
 */
export const getSSRdata = function(name) {
    const dom = document.querySelector(`[data-ssr=${ name }]`);
    return JSON.parse(dom.innerHTML);
}